import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TimesheetMultiplier, TimesheetMultiplierSearch } from '../timesheet-multiplier/timesheet-multiplier.model';
import { logRequest } from 'app/main/shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class TimesheetMultiplierService {
    baseUrl = '/school-service/api/timesheet-multiplier';

    constructor(private http: HttpClient) {}

    getAllActive(schoolId: string): Observable<TimesheetMultiplier[]> {
        return this.http.get<TimesheetMultiplier[]>(
            `/school-service/api/school/${schoolId}/timesheet-multiplier/active`
        );
    }

    getAllWorkingHoursRequired(schoolId: string): Observable<TimesheetMultiplier[]> {
        return this.http.get<TimesheetMultiplier[]>(
            `/school-service/api/school/${schoolId}/timesheet-multiplier/working-hours-required`
        );
    }

    createTimesheetMultiplier(timesheetMultiplier: TimesheetMultiplier): Observable<HttpResponse<TimesheetMultiplier>> {
        return this.http.post<TimesheetMultiplier>(this.baseUrl, timesheetMultiplier, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    updateTimesheetMultiplier(timesheetMultiplier: TimesheetMultiplier): Observable<HttpResponse<TimesheetMultiplier>> {
        return this.http.put<TimesheetMultiplier>(this.baseUrl, timesheetMultiplier, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    deleteTimesheetMultiplier(id: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, { observe: 'response', headers: logRequest() });
    }

    getTimesheetMultiplierById(id: string): Observable<HttpResponse<TimesheetMultiplier>> {
        return this.http.get<TimesheetMultiplier>(`${this.baseUrl}/${id}`, { observe: 'response' });
    }

    searchTimesheetMultiplier(search: TimesheetMultiplierSearch): Observable<HttpResponse<TimesheetMultiplier[]>> {
        return this.http.post<TimesheetMultiplier[]>(`${this.baseUrl}/search`, search, { observe: 'response' });
    }
}
